/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DiscordInfo } from './DiscordInfo';
import {
    DiscordInfoFromJSON,
    DiscordInfoFromJSONTyped,
    DiscordInfoToJSON,
    DiscordInfoToJSONTyped,
} from './DiscordInfo';

/**
 * 
 * @export
 * @interface DiscordInfoResponse
 */
export interface DiscordInfoResponse {
    /**
     * 
     * @type {DiscordInfo}
     * @memberof DiscordInfoResponse
     */
    discord?: DiscordInfo;
}

/**
 * Check if a given object implements the DiscordInfoResponse interface.
 */
export function instanceOfDiscordInfoResponse(value: object): value is DiscordInfoResponse {
    return true;
}

export function DiscordInfoResponseFromJSON(json: any): DiscordInfoResponse {
    return DiscordInfoResponseFromJSONTyped(json, false);
}

export function DiscordInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscordInfoResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'discord': json['discord'] == null ? undefined : DiscordInfoFromJSON(json['discord']),
    };
}

export function DiscordInfoResponseToJSON(json: any): DiscordInfoResponse {
    return DiscordInfoResponseToJSONTyped(json, false);
}

export function DiscordInfoResponseToJSONTyped(value?: DiscordInfoResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'discord': DiscordInfoToJSON(value['discord']),
    };
}

